import React, { useState } from 'react';
import { observer } from 'mobx-react';
import MarkdownContent from './MarkdownContent';
import EditWrapper from './EditWrapper';
import GeneralAsks from '../../components/CompanyOverview/GeneralAsks';
import {
  PageWrapper, PageHeader, PageTitle, EditButton, Card, CardTitle,
  EmptyState,
} from './CompanyPage.styles';

const GeneralAsksPage = observer(({ company, mode }) => {
  const [editing, setEditing] = useState(false);
  const isReadonly = mode === 'readonly';
  const asks = company?.generalAsks || [];

  if (editing) {
    return (
      <PageWrapper>
        <PageHeader>
          <PageTitle>General Asks</PageTitle>
        </PageHeader>
        <EditWrapper onBack={() => setEditing(false)}>
          <GeneralAsks company={company} saveCallback={() => setEditing(false)} />
        </EditWrapper>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <PageHeader>
        <PageTitle>General Asks</PageTitle>
        {!isReadonly && (
          <EditButton onClick={() => setEditing(true)}>
            {'\u270E'} Edit
          </EditButton>
        )}
      </PageHeader>

      {asks.length === 0 || (asks.length === 1 && !asks[0]?.trim()) ? (
        <EmptyState>No general asks have been added yet.</EmptyState>
      ) : (
        asks.filter(a => a?.trim()).map((ask, i) => (
          <Card key={i}>
            <CardTitle style={{ marginBottom: 12 }}>Ask #{i + 1}</CardTitle>
            <MarkdownContent markdown={ask} />
          </Card>
        ))
      )}
    </PageWrapper>
  );
});

export default GeneralAsksPage;
